import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=5a560e21&scoped=true&"
import script from "./Album.vue?vue&type=script&lang=js&"
export * from "./Album.vue?vue&type=script&lang=js&"
import style0 from "../assets/StyleSheet/Album.css?vue&type=style&index=0&id=5a560e21&scoped=true&lang=css&"
import style1 from "../assets/StyleSheet/About.css?vue&type=style&index=1&id=5a560e21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a560e21",
  null
  
)

export default component.exports